import api from './api';

export default async function getServicesBlob(url) {

  return api
    .get(url, 
    {
      headers: { 'Content-Type': 'application/json', },
      responseType: 'blob'
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {type:'error', data: {code: error.response.data.code, detail: error.response.data.detail}}
    });
}
